/**
 * Task Portal Services Module
 * SDK services for task portal operations.
 *
 * These services allow users to manage tasks they created or are assigned to
 * through dedicated portal endpoints with role-based access control.
 *
 * Security:
 * - All requests require JWT authentication
 * - Task creators have full CRUD permissions
 * - Task assignees have limited permissions (view, update status/progress, add comments/attachments)
 * - Server validates user's relationship to each task
 */
// Base service
export { TaskPortalBaseService } from './TaskPortalBaseService';
// Task operations
export { TaskPortalTaskService } from './TaskPortalTaskService';
// Comment management
export { TaskPortalCommentService } from './TaskPortalCommentService';
// Note management
export { TaskPortalNoteService } from './TaskPortalNoteService';
// Attachment management
export { TaskPortalAttachmentService } from './TaskPortalAttachmentService';
// Notification management
export { TaskPortalNotificationService } from './TaskPortalNotificationService';
// Assignment management
export { TaskPortalAssignmentService } from './TaskPortalAssignmentService';
// Dashboard
export { TaskPortalDashboardService } from './TaskPortalDashboardService';
// Project
export { TaskPortalProjectService } from './TaskPortalProjectService';
// Activity drawer feed
export { TaskPortalActivityFeedService } from './TaskPortalActivityFeedService';
// Models
export * from './models';
// Import for factory function
import { TaskPortalTaskService } from './TaskPortalTaskService';
import { TaskPortalCommentService } from './TaskPortalCommentService';
import { TaskPortalNoteService } from './TaskPortalNoteService';
import { TaskPortalAttachmentService } from './TaskPortalAttachmentService';
import { TaskPortalNotificationService } from './TaskPortalNotificationService';
import { TaskPortalAssignmentService } from './TaskPortalAssignmentService';
import { TaskPortalDashboardService } from './TaskPortalDashboardService';
import { TaskPortalProjectService } from './TaskPortalProjectService';
import { TaskPortalActivityFeedService } from './TaskPortalActivityFeedService';
/**
 * Create all task portal services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all task portal services
 */
export function createTaskPortalServices(http, config) {
    const tasks = new TaskPortalTaskService(http, config);
    const comments = new TaskPortalCommentService(http, config);
    const notes = new TaskPortalNoteService(http, config);
    const attachments = new TaskPortalAttachmentService(http, config);
    const notifications = new TaskPortalNotificationService(http, config);
    const assignments = new TaskPortalAssignmentService(http, config);
    const dashboard = new TaskPortalDashboardService(http, config);
    const projects = new TaskPortalProjectService(http, config);
    const activityFeed = new TaskPortalActivityFeedService(http, config);
    return {
        tasks,
        comments,
        notes,
        attachments,
        notifications,
        assignments,
        dashboard,
        projects,
        activityFeed,
    };
}
//# sourceMappingURL=index.js.map